import { DefaultButton, FontWeights, IButtonStyles, IconButton, IIconProps, mergeStyleSets, Modal, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IAttendee } from '../../../../../Models/Attendees/IAttendee';
import { MiniUserList } from '../../../Users/UserList/MiniUserList';
import { UserList } from '../../../Users/UserList/UserList';

interface IAddAttendeeRegistrationViewProps {
    isOpened: boolean;
    onDismiss: () => void;
    addRegistrations: (attendees: IAttendee[]) => void;
}


export const AddAttendeeRegistrationView: React.FunctionComponent<IAddAttendeeRegistrationViewProps> = (props) => {
    const [selectedAttendees, setSelectedAttendees] = React.useState<IAttendee[]>([]);

    const titleId = useId('title');
    const theme = useTheme();


    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [          
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };

    return (<Modal
        titleAriaId={titleId}
        isOpen={props.isOpened}
        onDismiss={props.onDismiss}
        isBlocking={false}
        containerClassName={contentStyles.container}>
        <div className={contentStyles.header}>
            <span id={titleId}>Přidání nového žáka</span>
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Zavři"
                onClick={props.onDismiss}/>
        </div>
        <div className={contentStyles.body}>
            <MiniUserList selectionChanged={setSelectedAttendees} />
        </div>
        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
            <PrimaryButton disabled={selectedAttendees.length === 0} onClick={() => props.addRegistrations(selectedAttendees)}>Uložit</PrimaryButton>
            <DefaultButton onClick={props.onDismiss}>Zavřít</DefaultButton>
        </Stack>
    </Modal>)

  

}
